<div class="contact-page-container container">
  <app-breadcrumbs></app-breadcrumbs>

  <div class="contact-main">
    <div class="contact-page">
      <h2 class="contact-page__heading" translate>Get in touch</h2>

      <app-block identifier="contact_form_description"></app-block>

      <form
        #contactFormRef="ngForm"
        [formGroup]="contactForm"
        class="contact-page__form"
        (ngSubmit)="onSubmit()"
      >
        <app-speedy-input
          class="contact-page__input"
          placeholder="Name"
          [control]="contactForm.controls.name"
        ></app-speedy-input>
        <app-speedy-input
          class="contact-page__input"
          placeholder="Email address"
          [control]="contactForm.controls.email"
        ></app-speedy-input>
        <app-speedy-input
          class="contact-page__input"
          placeholder="Phone number"
          type="number"
          [control]="contactForm.controls.phone"
        ></app-speedy-input>

        <app-speedy-textarea
          class="contact-page__textarea"
          placeholder="Add a comment"
          [rows]="10"
          [control]="contactForm.controls.message"
        >
        </app-speedy-textarea>

        <app-speedy-button
          class="contact-page__submit-button"
          text="Send"
          [loading]="isContactFormLoading"
        ></app-speedy-button>
      </form>
    </div>
    <div class="image-container">
      <app-block identifier="contact_us_image"></app-block>
    </div>
  </div>
</div>
